const PGN_HEX_PATTERN = /^0x[0-3](?:[0-9A-E][0-9A-F]00|F[0-9A-F]{3})$/i;

export function pgnValidator(control: { value: unknown }): { invalidPgn: boolean } | null {
    const value = control.value as string | null | undefined;
    if (!value) return null;
    return PGN_HEX_PATTERN.test(value) ? null : { invalidPgn: true };
}
